// import { useState, useEffect } from "react";
// import WithFieldData from "../HOK/withFieldData";
// import SmallProductCartSale from "../standartComponent/productComponent/smallProductCartSale";
// import css from "./main.module.css";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addFilter } from "../../function/filtersSlice";
// import { HandySvg } from "handy-svg";
// import arrow from "../../svg/arrow.svg";

// const AllRozprodagNew = ({ products, setCartCounterC, setLikeCounterC }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [startX, setStartX] = useState(null);
//   const [endX, setEndX] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (products.length > 0) {
//       setCurrentIndex(0);
//     }
//   }, [products]);

//   const goToRozprodag = () => {
//     dispatch(addFilter({ field: "rozprodaz", value: "true" }));
//     navigate("/catalog");
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev + 1) % products.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
//   };

//   const handleTouchStart = (e) => {
//     setStartX(e.touches[0].clientX);
//     setEndX(null);
//   };

//   const handleTouchMove = (e) => {
//     if (startX !== null) {
//       setEndX(e.touches[0].clientX);
//     }
//   };

//   const handleTouchEnd = () => {
//     if (startX !== null && endX !== null) {
//       const delta = startX - endX;
//       if (delta > 50) handleNext();
//       else if (delta < -50) handlePrev();
//     }
//     setStartX(null);
//     setEndX(null);
//   };

//   const handleMouseDown = (e) => {
//     setIsDragging(true);
//     setStartX(e.clientX);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setEndX(e.clientX);
//     }
//   };

//   const handleMouseUp = () => {
//     if (isDragging && startX !== null && endX !== null) {
//       const delta = startX - endX;
//       if (delta > 50) handleNext();
//       else if (delta < -50) handlePrev();
//     }
//     setIsDragging(false);
//     setStartX(null);
//     setEndX(null);
//   };

//   return (
//     <div
//       className={css.oneProdWrapNew}
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//       style={{ touchAction: "none", userSelect: "none" }}
//     >
//       <p className={css.nameOfAcrRozprodag} onClick={goToRozprodag}>
//         Весь розпродаж
//       </p>

//       {products.length > 0 && (
//         <div className={css.sliderWrap}>
//           <SmallProductCartSale
//             el={products[currentIndex]}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//           <HandySvg
//             src={arrow}
//             className={css.arrovIconBanner}
//             width="52"
//             height="49.56"
//             onClick={handleNext}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default WithFieldData("rozprodaz", "product", "true")(AllRozprodagNew);
import { useState, useEffect } from "react";
import WithFieldData from "../HOK/withFieldData";
import SmallProductCartSale from "../standartComponent/productComponent/smallProductCartSale";
import css from "./main.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter } from "../../function/filtersSlice";
import { HandySvg } from "handy-svg";
import arrow from "../../svg/arrow.svg";

// ⬇️ ДОДАТКОВО: Firestore
import { db } from "../../firebase";
import { getDocs, collection } from "firebase/firestore";

const AllRozprodagNew = ({
  products: propProducts,
  setCartCounterC,
  setLikeCounterC,
}) => {
  const [allProducts, setAllProducts] = useState([]);
  const [sales, setSales] = useState([]);
  const [combinedProducts, setCombinedProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 1) Підтягуємо всі товари + усі розпродажі
  useEffect(() => {
    const fetchAllProducts = async () => {
      const snap = await getDocs(collection(db, "product"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setAllProducts(list);
    };
    const fetchSales = async () => {
      const snap = await getDocs(collection(db, "sales"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setSales(list);
    };
    fetchAllProducts();
    fetchSales();
  }, []);

  // 2) Формуємо комбінований список: товари з пропса (флаг rozprodaz=true) + товари з активних розпродажів
  useEffect(() => {
    if (!allProducts.length || !sales.length) {
      // якщо нема sales або allProducts — показуємо лише те, що прийшло з пропа
      setCombinedProducts(propProducts || []);
      setCurrentIndex(0);
      return;
    }

    const now = new Date();

    const toArray = (val) =>
      Array.isArray(val) ? val : typeof val === "string" && val ? [val] : [];

    const getAuthorsFromProduct = (p) => {
      // Під різні варіанти полів у товарі
      const acc = [];
      if (Array.isArray(p.author)) acc.push(...p.author);
      if (typeof p.author === "string") acc.push(...p.author.split(","));
      if (typeof p.textAutor === "string") acc.push(...p.textAutor.split(","));
      return acc.map((s) => s.trim()).filter(Boolean);
    };

    const getSeriesFromProduct = (p) => {
      // series може бути масивом або рядком
      if (Array.isArray(p.series)) return p.series.filter(Boolean);
      if (typeof p.series === "string")
        return p.series
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      return [];
    };

    const activeSaleProducts = allProducts.flatMap((product) => {
      const productSeries = getSeriesFromProduct(product);
      const productAuthors = getAuthorsFromProduct(product);
      const productIds = [product.id, product.uid].filter(Boolean); // інколи ти використовуєш uid

      const matchedSale = sales.find((sale) => {
        const start = sale.startDate ? new Date(sale.startDate) : null;
        const end = sale.endDate ? new Date(sale.endDate) : null;

        if (end && now > end) return false;
        if (start && now < start) return false;

        const applies = sale.appliesTo || {};
        const matchesProduct =
          Array.isArray(applies.products) &&
          applies.products.some((pid) => productIds.includes(pid));

        const matchesSeries =
          Array.isArray(applies.series) &&
          productSeries.some((ser) => applies.series.includes(ser));

        const matchesAuthor =
          Array.isArray(applies.authors) &&
          productAuthors.some((a) => applies.authors.includes(a));

        return matchesProduct || matchesSeries || matchesAuthor;
      });

      if (matchedSale) {
        return {
          ...product,
          saleDiscountPercent: Number(matchedSale.discountPercent) || 0,
        };
      }
      return [];
    });

    // зліплюємо: propProducts (розпродажні за флагом) + знайдені за правилами sales
    const haveKey = (p) => p?.id || p?.uid;
    const propKeys = new Set((propProducts || []).map(haveKey).filter(Boolean));
    const merged = [
      ...(propProducts || []),
      ...activeSaleProducts.filter((p) => !propKeys.has(haveKey(p))),
    ];

    setCombinedProducts(merged);
    setCurrentIndex(0);
  }, [allProducts, sales, propProducts]);

  // 3) переходи
  useEffect(() => {
    if (combinedProducts.length > 0) setCurrentIndex(0);
  }, [combinedProducts]);

  const goToRozprodag = () => {
    dispatch(addFilter({ field: "rozprodaz", value: "true" }));
    navigate("/catalog");
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      combinedProducts.length ? (prev + 1) % combinedProducts.length : 0
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      combinedProducts.length
        ? prev === 0
          ? combinedProducts.length - 1
          : prev - 1
        : 0
    );
  };

  // touch / mouse
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setEndX(null);
  };
  const handleTouchMove = (e) => {
    if (startX !== null) setEndX(e.touches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) handleNext();
      else if (delta < -50) handlePrev();
    }
    setStartX(null);
    setEndX(null);
  };
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };
  const handleMouseMove = (e) => {
    if (isDragging) setEndX(e.clientX);
  };
  const handleMouseUp = () => {
    if (isDragging && startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) handleNext();
      else if (delta < -50) handlePrev();
    }
    setIsDragging(false);
    setStartX(null);
    setEndX(null);
  };

  return (
    <div
      className={css.oneProdWrapNew}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      style={{ touchAction: "none", userSelect: "none" }}
    >
      <p className={css.nameOfAcrRozprodag} onClick={goToRozprodag}>
        Весь розпродаж
      </p>

      {combinedProducts.length > 0 ? (
        <div className={css.sliderWrap}>
          <SmallProductCartSale
            el={combinedProducts[currentIndex]}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <HandySvg
            src={arrow}
            className={css.arrovIconBanner}
            width="52"
            height="49.56"
            onClick={handleNext}
          />
        </div>
      ) : (
        <p>Товари розпродажу зараз відсутні</p>
      )}
    </div>
  );
};

export default WithFieldData("rozprodaz", "product", "true")(AllRozprodagNew);
